import { Component, Inject } from '@angular/core';
import { MatSnackBarRef, MAT_SNACK_BAR_DATA, MatSnackBarAction } from '@angular/material/snack-bar';
import { AssetUrlPipe } from '../../pipes/asset-url.pipe';


@Component({
    selector: 'collaboration-ui-snackbar',
    templateUrl: './snackbar.component.html',
    styleUrls: ['./snackbar.component.scss'],
    imports: [MatSnackBarAction, AssetUrlPipe]
})
export class SnackbarComponent {
  dataObject: any;
  constructor(public snackBarRef: MatSnackBarRef<any>, @Inject(MAT_SNACK_BAR_DATA) public data: { message: string, type: string }) {
    this.dataObject = data;
  }
  closeSnackbar() {
    this.snackBarRef.dismiss();
  }
  actionButtonClick() {
    this.snackBarRef.dismissWithAction();
  }
}
